import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import {Link} from 'react-router-dom';
import React, {Component} from 'react';

import Map from '../Base/Map';
import Layout from '../Base/Layout';
import OrdersApi from '../../api/Orders';
import {translate} from '../../utils/i18n'

class ContactsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            telephone: "",
            email: "",
            attachment: null,
            comment: "",
            showConfirmModal: false
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();

        let d = {
            serviceType: 'FEEDBACK',
            userName: this.state.name,
            contactData: this.state.telephone + " " + this.state.email,
            comments: this.state.comment,
            languageName: "todo",
        };
        if (this.state.attachment != null) {
            OrdersApi.createWithFiles(d, this.state.attachment).then(e => {
                this.setState({showConfirmModal: true});
            });
            return;
        }

        OrdersApi.create(d).then(e => {
            this.setState({showConfirmModal: true});
        })

    }

    render() {
        let {isGoogleApiInit, defaultLat, officeLat, officeLng, i18n} = this.props;

        return (
            <Layout
                showPromoContent={false}
                title={translate('contactsPage.document.title', i18n) !== undefined ? translate('contactsPage.document.title', i18n) : ''}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <Link to="/" className="cancel">{translate('contactsPage.back', i18n)}</Link>
                        <div className="clearfix heading">
                            <h2>
                                {translate('contactsPage.title', i18n)}
                            </h2>
                        </div>
                        <div className="clearfix informer-table">
                            <div className="pab-row clearfix">
                                <div className="pab-cell">
                                    <b>{translate('contactsPage.address', i18n)}:</b>
                                    <div
                                        dangerouslySetInnerHTML={{__html: translate("contactPage.addressHtmlContent", i18n)}}/>
                                </div>
                                <div className="pab-cell">
                                    <b>{translate('contactsPage.contacts', i18n)}:</b>
                                    <div
                                        dangerouslySetInnerHTML={{__html: translate("contactPage.contactsHtmlContent", i18n)}}/>
                                </div>
                                <div className="pab-cell">
                                    <b>{translate('contactsPage.emails', i18n)}:</b>
                                    <div
                                        dangerouslySetInnerHTML={{__html: translate('contactPage.emailsHtmlContent', i18n)}}/>
                                </div>
                            </div>
                            <div className="geo-pab">
                                {isGoogleApiInit && defaultLat !== undefined && <Map
                                    id="map"
                                    zoom={16}
                                    className="map"
                                    lat={officeLat}
                                    lng={officeLng}
                                    isContactsMap={true}
                                    centerLat={officeLat}
                                    centerLng={officeLng}
                                />}
                            </div>
                        </div>
                        <div className="clearfix form-contact">
                            <span>{translate('contactsPage.form.title', i18n)}</span>
                            <div>
                                <form>
                                    <input type="text"
                                           placeholder={translate('contactsPage.form.placeholder.name', i18n)}
                                           value={this.state.name} onChange={e => {
                                        this.setState({name: e.target.value})
                                    }}/>
                                    <input type="text"
                                           placeholder={translate('contactsPage.form.placeholder.telephone', i18n)}
                                           value={this.state.telephone} onChange={e => {
                                        this.setState({telephone: e.target.value})
                                    }}/>
                                    <input type="text"
                                           placeholder={translate('contactsPage.form.placeholder.email', i18n)}
                                           value={this.state.email} onChange={e => {
                                        this.setState({email: e.target.value})
                                    }}/>
                                    <label>
                                        {this.state.attachment === null ? translate('contactsPage.form.placeholder.attachment', i18n) : this.state.attachment.map(e => e[1].name).join(",")}
                                        <input type="file" onChange={e => {
                                            let a = [];
                                            Object.entries(e.target.files).forEach(item => {
                                                a.push(item)
                                            });
                                            this.setState({attachment: a});
                                        }} multiple/>
                                    </label>
                                    <textarea placeholder={translate('contactsPage.form.placeholder.comment', i18n)}
                                              value={this.state.comment} onChange={e => {
                                        this.setState({comment: e.target.value})
                                    }}/>
                                    <input type="submit" value={translate('contactsPage.form.send', i18n)}
                                           onClick={this.onSubmit}/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <ReactModal
                    className="custom-react-modal"
                    isOpen={this.state.showConfirmModal}
                    overlayClassName="custom-react-modal-overlay"
                >
                    {translate('objectPage.callbackConfirmMessage', i18n)}
                    <br/><br/>
                    <button onClick={() => {
                        this.setState({showConfirmModal: false})
                    }} className="btn">
                        {translate('objectPage.callbackClose', i18n)}
                    </button>
                </ReactModal>

            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    officeLat: state.configuration.main.officeLat,
    officeLng: state.configuration.main.officeLng,
    defaultLat: state.configuration.main.defaultLat,
    isGoogleApiInit: state.configuration.isGoogleApiInit
});

export default connect(mapStateToProps)(ContactsPage);



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsPage.js